<div class="row m--full-bleed mb-3">
  <div class="col-12 form-display-card">
    <mat-card class="card-container">
      <mat-card-header>
        <mat-card-title>
          
            
            <button (click)="displayRoutingHelp()" class="ico-btn dib ml-1">
                <h2 class="mat-card-title mb-0">
                {{title}}
              <span class="fa fa-question-circle fa-sm-blue mx-1" matTooltip="WHERE IS MY ROUTING AND ACCOUNT NUMBER"
                matTooltipClass="tooltip-md">
              </span>
              </h2>
            </button>
          
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="bankaccountFrmGp" (keyup.enter)="insertUpdateAccount()" (ngSubmit)="insertUpdateAccount()">
          <div class="flex-input-col pt-2 pb-2">
            <mat-radio-group aria-label="Select an option" formControlName="accountType" required>
              <mat-radio-button value="CHK">Checking</mat-radio-button>
              <mat-radio-button value="SAV">Savings</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-error *ngIf="bankaccountFrmGp.get('accountType')!.hasError('required') && submitted">Bank
            account type
            required.
          </mat-error>

          <div class="flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput maxlength="25" placeholder="Bank Name" formControlName="bankName" required
                autocomplete="off">
              <mat-hint>Must be less than 25 character.
                ({{bankaccountFrmGp.get('bankName')!.value.length}}/25)</mat-hint>
              <mat-error>Required</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Bank Phone Number" formControlName="bankphone" autocomplete="off"
                mask="(000) 000-0000">
            </mat-form-field>
          </div>
          <div *ngIf="!isEdit" formGroupName="routingGrp" class="flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="Routing Number" [type]="routingHide ? 'password' : 'text'"
                formControlName="routing1" autocomplete="off" required>
              <mat-icon matSuffix (click)="toggleRoutingHide()">
                {{ routingHide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="bankaccountFrmGp.get('routingGrp.routing1')?.hasError('required')">Required</mat-error>
              <mat-error *ngIf="bankaccountFrmGp.get('routingGrp.routing1')?.hasError('abaInvalid')">
                Invalid Bank Routing Number
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput [errorStateMatcher]="errorMatcher" [type]="routingConfirmHide ? 'password' : 'text'"
                placeholder="Confirm Routing Number" formControlName="routing2" autocomplete="off" required>
              <mat-icon matSuffix (click)="toggleRoutingConfirmHide()">
                {{ routingConfirmHide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="bankaccountFrmGp.get('routingGrp')?.hasError('doNotMatch')">
                Routing numbers do not match.
              </mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="!isEdit" formGroupName="accountGrp" class="flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="Account Number" [type]="accountHide ? 'password' : 'text'"
                formControlName="account1" autocomplete="off" required>
              <mat-icon matSuffix (click)="toggleAccountHide()">
                {{ accountHide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error>Required</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput [errorStateMatcher]="errorMatcher" [type]="accountConfirmHide ? 'password' : 'text'"
                placeholder="Confirm Account Number" formControlName="account2" autocomplete="off" required>
              <mat-icon matSuffix (click)="toggleAccountConfirmHide()">
                {{ accountConfirmHide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error *ngIf="bankaccountFrmGp.get('accountGrp')?.hasError('doNotMatch')">
                Account numbers do not match.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="pt-2 pb-2" *ngIf="accountHasHold">
            <span class="fa fa-exclamation-triangle fa-md-red"></span>
            <span class="c-red1">
              This bank account is currently on hold and not eligible for ACH debit
            </span>
          </div>
          <div class="flex-btn-row pt-2 pb-2">
            <button class="btn btn-secondary" mat-raised-button type="button" (click)="closePanel()">Close</button>
            <button class="btn btn-submit" mat-raised-button type="submit">Save Account</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>